<script>
import TopBar from "@layouts/top-bar";
import NavBar from "@layouts/nav-bar";
import RightBar from "@layouts/right-bar";
import Footer from "@layouts/footer";

export default {
  components: {
    TopBar,
    NavBar,
    RightBar,
    Footer
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alertVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isMenuOpened: false
    };
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    },
    modal() {
      return this.$store.state.modal;
    },
    showAlert() {
      return this.alertVisible && this.alert.show && !this.modal.isVisible;
    }
  },
  created() {
    this.$store.dispatch("modal/clear");
    this.$store.dispatch("alert/clear");
  },
  methods: {
    toggleMenu() {
      this.isMenuOpened = !this.isMenuOpened;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <div>
    <header id="topnav">
      <TopBar>
        <NavBar :is-menu-opened="isMenuOpened" />
      </TopBar>
    </header>

    <div class="wrapper">
      <div class="container-fluid">
        <b-alert
          variant="danger"
          dismissible
          :show="showAlert"
          @dismissed="closeAlert"
        >
          {{ alert.message }}
        </b-alert>
        <slot />
      </div>
      <Footer />
      <RightBar />
    </div>
  </div>
</template>
<style lang="scss">
body {
  background-image: none;
}
</style>
